import  { useState, Fragment, useLayoutEffect, useRef } from "react";
import "./CommonStyle/CommonStyle.css";
import Collapse from "@mui/material/Collapse";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ListItemIcon from "@mui/material/ListItemIcon";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { DrawerURLs } from "../Drawer/DrawerContext/DrawerURLs";
import { useLocation } from "react-router";

const CustomListItem = (props) => {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  const childrenLinks = props?.children?.props?.children || [];

  const linksList = childrenLinks?.map((links) => links?.props?.href);

  const handleClick = (propOnClick) => (ev) => {
    if (propOnClick) propOnClick(ev);
    setOpen((prev) => !prev);
  };

  const handleBlur = (e) => {
    setTimeout(() => {
      const active = document.activeElement;
      const stillInside = wrapperRef.current?.contains(active);

      if (!stillInside) {
        if (!linksList?.includes(location?.pathname)) {
          setOpen(false);
        }
      }
    }, 1000);
  };

  const moreIcon = open ? (
      <ExpandLess className="expandless-button" />
  ) : (
      <ExpandMore className="expandless-button" />
  );

  const selectedDrawer = DrawerURLs()?.Urls?.filter(
      (x) => x?.name === props?.text
  )[0];

  const selectedDrawerChildren = DrawerURLs()?.Urls?.filter(
      (x) => x?.name === props?.text
  )[0]?.children;

  const presentURL =
      location?.pathname?.split("/")[2] || location?.pathname?.split("/")[1];

  const presentDrawerURL =
      selectedDrawer?.href?.split("/")[2] ||
      selectedDrawer?.href?.split("/")[1] ||
      selectedDrawerChildren?.[0]?.href?.split("/")[2];

  useLayoutEffect(() => {
    presentURL === presentDrawerURL && setOpen(!open);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [presentDrawerURL]);

  return (
      <Fragment>
        <div ref={wrapperRef} tabIndex={-1} onBlur={handleBlur}>
          <ListItemButton
              className={`list-button ${
                  presentURL === presentDrawerURL ? "list-button-active" : ""
              }
        ${
                  props.href === location.pathname
                      ? "list-button-active-child !bg-[#ECDFF2]"
                      : ""
              }
         `}
              selected={!!props.selected}
              onClick={handleClick(props.onClick)}
              href={props.href || null}
          >
            {props?.onClick ? null : (
                <ArrowForwardIosIcon sx={{ fontSize: 12 }} />
            )}
            <ListItemIcon className="list-icons">{props.icon}</ListItemIcon>
            <ListItemText className="list-item-text" primary={props.text || ""} />
            {!props.children ? null : moreIcon}
          </ListItemButton>
        </div>
        {!props.children ? null : (
            <Collapse
                className="list-collapse"
                in={open}
                timeout="auto"
                unmountOnExit
            >
              {props.children}
            </Collapse>
        )}
      </Fragment>
  );
};

export default CustomListItem;
